export const iconFontAwesomeMedicalHealthPersonCane = (
	<i className="fa-solid fa-person-cane"></i>
);
